<template>
    <div class="flex items-center justify-between">
        <div>
            <span class="text-16 lg:text-18 font-bold text-a-brown-502314">Turn Notification</span>
        </div>
        <div>
            <Switcher v-model="isNotificationOn"></Switcher>
        </div>
    </div>
</template>
<script>
import { ref, unref, watch } from 'vue'
// component
import Switcher from '@/components/Input/simple/Switcher.vue'
export default {
    name: 'NotificationToggle',
    props: {
        modelValue: {
            type: Boolean
        }
    },
    components: {
        Switcher
    },
    mixins: [],
    emits: ["update:modelValue"],
    data: function () { return {} },
    computed: {},
    setup: function (props, context) {
        const isNotificationOn = ref(unref(props.modelValue))

        watch(isNotificationOn, (val) => {
            if (val) {
                localStorage.setItem("notificationsEnabled", true)
                context.emit("update:modelValue", true)
            } else {
                localStorage.setItem("notificationsEnabled", false)
                context.emit("update:modelValue", false)
            }
        })

        return {
            isNotificationOn
        }
    },
    mounted: function () { },
    methods: {}
}
</script>
